// ActionButtons.js
import React from 'react';
import { IconButton, Switch, Tooltip } from "@mui/material";

const ActionButtons = ({ buttons }) => (
    <div className="row hive-action-buttons">
        <div className="col">
            {buttons.map(({ title, onClick, icon: Icon, color, toggle, showArchived, disabled }, idx) => (
                <Tooltip key={idx} title={title}>
                    {
                        toggle ? (
                            <Switch
                                checked={showArchived} // ✅ bind state here
                                onChange={onClick}
                        />
                        ) : (

                    <span><IconButton aria-label={title} disabled={disabled} onClick={onClick} className="hive-action-button">
                        <Icon color={color || "primary"} />
                    </IconButton></span>
                        )
                    }
                </Tooltip>
            ))}
        </div>
    </div>
);

export default ActionButtons;
